import { useContext } from "react";

import {
	OfferOptionsContext,
	TOfferOptionsContext,
} from "@state/context/offer/OfferOptionContext";

/**
 * CURRENTLY MOBILE SPECIFIC HOOK
 * IT WILL BREAK ON LOAD IF IT'S IMPORTED ON DESKTOP
 */
export function useOfferOptionsContext(): TOfferOptionsContext {
	const offerOptions = useContext(OfferOptionsContext);
	if (offerOptions == null) {
		throw Error("Offer options context does not exists");
	}

	return offerOptions;
}
